/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICittaStoreLocationsV2ViewProps } from './citta-store-locations-v2';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

export default (props: ICittaStoreLocationsV2ViewProps) => {
    const { CittaStores, CittaStoreLocations, CittaStoresList } = props;
    return (
        <Module {...CittaStores}>
            <Node {...CittaStoreLocations} className='row'>
                {CittaStoresList}
            </Node>
        </Module>) 
};
